export default {"src":"/_next/static/media/medal.8af4ef57.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};